export default __webpack_public_path__ + "static/media/delievers7.9d02e682.png";